import {
  GET_FILTERED_DATA,
  SET_FILTERED_DATA,
  SET_SELECTED_QUESTION,
  SET_DATA_DATES,
  SET_CATEGORY_DATA,
  SET_RAW_DATA,
  CLEAR_ALL,
  SET_QUESTIONS,
  SET_SUB_NAV,
  SET_NAVIGATION,
  SET_SELECTED_FILTERS,
  SET_DATA_ACNHOR,
  SET_FILTERED_LAST_DATA,
  SET_SURVEY_VERSION,
  SET_NEW_FILTERS,
  SET_CORE_DATA,
  SET_NEW_NAVIGATION,
  SET_SELECTED_GROUP,
  SET_SELECTED_DATE_FILTER,
  SET_ORIGINAL_DATA_DATES,
} from "constants/actions";

const initialState = {
  filtered_data: [],
  filtered_last_data: [],
  question_structure: {},
  category_structure: {},
  selected: { id: 0 },
  selectedGroup: [{ id: -1 }],
  dates: [],
  originalDates: null, // Add new state property to store original dates
  raw_data: [],
  sub: 1,
  filters: [],
  new_filters: [],
  anchor: null,
  nav: null,
  survey_version: null,
  core_data: null,
  selectedDateFilter: null,
  new_navigation: {
    selected1: null,
    selected2: null,
    selected3: null,
  },
};

export default function Audit(state = initialState, action) {
  switch (action.type) {
    case SET_FILTERED_DATA:
      return {
        ...state,
        filtered_data: action.payload,
      };
    case SET_NEW_FILTERS:
      return {
        ...state,
        new_filters: action.payload,
      };
    case SET_FILTERED_LAST_DATA:
      return {
        ...state,
        filtered_last_data: action.payload,
      };
    case SET_SELECTED_QUESTION:
      return {
        ...state,
        selected: action.payload,
      };

    case SET_SELECTED_GROUP:
      return {
        ...state,
        selectedGroup: action.payload,
      };

    case SET_SURVEY_VERSION:
      return {
        ...state,
        survey_version: action.payload,
      };
    case SET_DATA_DATES:
      return {
        ...state,
        dates: action.payload,
      };
    case SET_ORIGINAL_DATA_DATES:
      console.log("Setting originalDates:", action.payload);
      return {
        ...state,
        originalDates: action.payload,
      };
    case SET_CATEGORY_DATA:
      return {
        ...state,
        category_structure: action.payload,
      };
    case SET_DATA_ACNHOR:
      return {
        ...state,
        anchor: action.payload,
      };
    case SET_RAW_DATA:
      console.log("=== REDUX SET_RAW_DATA REDUCER ===");
      console.log("Previous raw_data length:", state.raw_data?.length || 0);
      console.log("Previous metadata:", state.raw_data?.[0]?.datasetMetadata);
      console.log("New raw_data length:", action.payload?.length || 0);
      console.log("New metadata:", action.payload?.[0]?.datasetMetadata);
      console.log("First new item responses:", action.payload?.[0]?.responses?.length);
      console.log("Stack trace:", new Error().stack);
      console.log("=== END REDUX DEBUG ===");
      
      return {
        ...state,
        raw_data: action.payload,
      };
    case SET_QUESTIONS:
      return {
        ...state,
        question_structure: action.payload,
      };
    case SET_SUB_NAV:
      return {
        ...state,
        sub: action.payload,
      };
    case SET_NAVIGATION:
      return {
        ...state,
        nav: action.payload,
      };
    case SET_SELECTED_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case SET_CORE_DATA:
      return {
        ...state,
        core_data: action.payload,
      };
    case SET_NEW_NAVIGATION:
      return {
        ...state,
        new_navigation: action.payload,
      };
    case SET_SELECTED_DATE_FILTER:
      console.log("Setting selectedDateFilter:", action.payload);
      return {
        ...state,
        selectedDateFilter: action.payload,
      };
    case CLEAR_ALL:
      console.log("=== REDUX CLEAR_ALL ACTION TRIGGERED ===");
      console.log("DESTROYING CUSTOM DATA!");
      console.log("Previous raw_data length:", state.raw_data?.length || 0);
      console.log("Previous metadata:", state.raw_data?.[0]?.datasetMetadata);
      console.log("Stack trace:", new Error().stack);
      console.log("=== CLEAR_ALL WILL RESET raw_data TO [] ===");
      
      return {
        ...state,
        filtered_data: [],
        question_structure: {},
        category_structure: {},
        dates: [],
        originalDates: null, // Clear original dates too
        raw_data: [],
        sub: 1,
        selected: { id: 0 },
        nav: {},
        filters: [],
        new_filters: [],
        core_data: null,
        new_navigation: {
          selected1: null,
          selected2: null,
          selected3: null,
        },
        anchor: null,
        survey_version: null,
        filtered_last_data: [],
        selectedDateFilter: null,
      };
    default:
      return state;
  }
}
